import React from "react";

const Good = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="77"
      height="77"
      viewBox="0 0 77 77"
      fill="none"
    >
      <path
        d="M38.5 77C59.763 77 77 59.763 77 38.5C77 17.237 59.763 0 38.5 0C17.237 0 0 17.237 0 38.5C0 59.763 17.237 77 38.5 77Z"
        fill="#FBC926"
      />
      <path
        d="M34 72.6984C24.9 72.6984 16.6 69.4984 10 64.2984C17 72.0984 27.2 76.9984 38.5 76.9984C59.8 76.9984 77 59.7984 77 38.4984C77 26.2984 71.3 15.4984 62.5 8.39844C68.7 15.1984 72.5 24.2984 72.5 34.1984C72.5 55.4984 55.2 72.6984 34 72.6984Z"
        fill="#F4BF11"
      />
      <path
        d="M59.8005 39.6969C59.6005 39.5969 54.3005 36.7969 38.3005 36.7969C24.0005 36.7969 17.2005 39.5969 16.9005 39.6969C16.5005 39.8969 16.3005 40.1969 16.4005 40.5969C18.3005 51.1969 27.5005 58.8969 38.3005 58.8969C49.1005 58.8969 58.3005 51.1969 60.2005 40.5969C60.3005 40.1969 60.2005 39.7969 59.8005 39.6969Z"
        fill="#332F2E"
      />
      <path
        d="M57.2996 48.3C53.4996 45.3 48.6996 43.5 43.4996 43.5C35.5996 43.5 28.4996 47.7 24.5996 54.1C28.3996 57.1 33.1996 58.9 38.3996 58.9C46.2996 58.8 53.2996 54.7 57.2996 48.3Z"
        fill="#CA68A0"
      />
      <path
        d="M16.8996 29.1984C16.1996 29.1984 15.5996 28.5984 15.5996 27.8984C15.5996 24.8984 17.9996 22.3984 21.0996 22.3984C22.9996 22.3984 24.7996 23.3984 25.7996 25.0984C26.1996 25.6984 25.8996 26.4984 25.2996 26.7984C24.6996 27.1984 23.8996 26.8984 23.5996 26.2984C23.0996 25.3984 22.0996 24.8984 21.0996 24.8984C19.4996 24.8984 18.1996 26.1984 18.1996 27.7984C18.1996 28.5984 17.5996 29.1984 16.8996 29.1984Z"
        fill="#332F2E"
      />
      <path
        d="M60.1003 29.2C59.4003 29.2 58.8003 28.6 58.8003 27.9C58.8003 26.3 57.5003 25 55.9003 25C54.9003 25 53.9003 25.6 53.4003 26.4C53.0003 27 52.3003 27.2 51.7003 26.9C51.1003 26.5 50.9003 25.8 51.2003 25.2C52.2003 23.5 54.0003 22.5 55.9003 22.5C58.9003 22.5 61.4003 24.9 61.4003 28C61.4003 28.6 60.8003 29.2 60.1003 29.2Z"
        fill="#332F2E"
      />
    </svg>
  );
};

export default Good;
